import styled from '@emotion/styled'

export const cardBorderColor = p => p.theme.primaryLighter ?? '#d4ebf2'

// Shared mobile card border. Callers provide layout, padding, and background.
export const MobileCardFrame = styled.div`
  border: 2px solid ${cardBorderColor};
  border-radius: 10px;
`

// `planned` applies to both RECOMMENDED and YOUR CHANGES column headings.
export const AdviceColumnHeading = styled.div`
  font-size: 11px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: ${p => (p.planned ? 700 : 400)};
  color: ${p => (p.planned ? p.theme.primaryColor : p.theme.lightestGray)};
`

export const AdviceMobileHeading = styled.div`
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: 700;
  color: ${p => p.theme.primaryColor};
`

// Adapted from ActionSmallArrowDefaultSVG.svg and recentered because the
// exported path was off-canvas.
export const ArrowGlyph = ({ className }) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    aria-hidden='true'>
    <path
      d='M20.8 11.996l-1.142 1.187-.008-.01-3.992 4.183a.789.789 0 0 1-1.14.002.86.86 0 0 1-.002-1.19l3.183-3.333H4.841a.841.841 0 1 1 0-1.681l12.881-.001-3.17-3.32a.86.86 0 0 1 .001-1.19.789.789 0 0 1 1.14.002l5.107 5.351z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
)
